module.exports = __webpack_public_path__ + "img/approve-list9.258ab494.png";